<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Booking Update History</span><br/>
      <span style="font-style: italic; font-size: 18px">history of booking record updates received from TBN over a date range</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Search</b-button>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Filter Results&nbsp;<b-form-input style="width: 260px" v-model="text_filter" placeholder="booking id"/>
    </div>

    <div v-if="!loading">
      <div class="row" style="margin: 30px 10px 30px 10px; font-weight: bold; font-size: 22px;">
        <div class="col" style="border: 1px solid grey;">Total: {{summary.total_cnt}}</div>
        <div class="col" style="border: 1px solid grey;">Filtered: {{items.length}}</div>
      </div>
    </div>

    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeSmall}}
        </template>

        <template slot="booking_id" slot-scope="row">
          <router-link v-if="row.item.booking_id" style="font-weight: bold;" :to="{ name: 'actuals_tbn', query: { booking_id: row.item.booking_id } }">{{ row.item.booking_id }}</router-link>
        </template>

        <template slot="payload_diff" slot-scope="row">
          <b-button v-if="has_changes(row.item)" size="sm" variant="outline-primary" v-on:click.prevent="open_changes(row.item)">Show Changes</b-button>
          <span v-else class="text-muted">&mdash;</span>
        </template>

      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>

    <b-modal v-model="changes_modal_visible" :title="changes_modal_title" size="lg" ok-only ok-title="Close" scrollable>
      <div v-if="changes_modal_changes.length" class="chg-view">
        <div v-for="(c, i) in changes_modal_changes" :key="i" class="chg-row">
          <div class="chg-label">{{ c.label }}</div>
          <div class="chg-val">
            <template v-if="c.type === 'changed'">
              <span class="chg-old">{{ c.old }}</span>
              <span class="chg-arrow">&rarr;</span>
              <span class="chg-new">{{ c.new }}</span>
            </template>
            <template v-else-if="c.type === 'added'">
              <span class="chg-tag chg-tag-added">added</span>
              <span class="chg-new">{{ c.new }}</span>
            </template>
            <template v-else>
              <span class="chg-tag chg-tag-removed">removed</span>
              <span class="chg-old">{{ c.old }}</span>
            </template>
          </div>
        </div>
      </div>
      <div v-else class="text-muted">{{ changes_modal_empty_msg }}</div>
    </b-modal>
  </div>
</template>

<script>

import { get_tbn_booking_history_range } from '../networking/tbn_apis'
import {mapState} from "vuex";
import moment from 'moment'
import {justDate} from "@/helpers/dates";

export default {
  name: 'booking_update_history',
  components: {
  },

  data() {
    return {
      text_filter: '',
      items: [],
      items_full: [],
      summary: [],
      loading: true,
      details_fromDate: justDate(moment().add(-1, 'days')),
      details_toDate: justDate(moment()),
      currentPage: 1,
      perPage: 100,
      changes_modal_visible: false,
      changes_modal_title: '',
      changes_modal_changes: [],
      changes_modal_empty_msg: '',
      fields: [
        { key: 'processed_time', label: 'Updated', sortable: true},
        { key: 'booking_id', label: 'Booking', sortable: true},
        { key: 'payload_diff', label: 'Changes', sortable: false},
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },

    }
  },

  async created() {
    this.load_data()
  },
  methods: {
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_tbn_booking_history_range(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary || {}
        if (this.summary && this.summary.timezone)
          moment.tz.setDefault(this.summary.timezone)
        this.items = data.records || []
        this.items_full = data.records || []
        this.filter_results()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_results() {
      this.items = this.items_full || []
      if (this.text_filter != '') {
        const val = this.text_filter
        this.items = this.items.filter(item => (this.contains(String(item.booking_id), val)))
      }
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    has_changes(item) {
      const diff = item && item.payload_diff != null ? String(item.payload_diff).trim() : ''
      return diff !== '' && diff.toLowerCase() !== 'none' && diff !== '{}'
    },
    open_changes(item) {
      this.changes_modal_title = 'Booking ' + (item.booking_id || '') + ' @ ' + moment(item.processed_time).format('MM-DD-YYYY h:mm A')
      const previous = this.previous_record(item)
      if (previous && previous.payload && item.payload) {
        this.changes_modal_changes = this.compute_changed_fields(previous.payload, item.payload)
        this.changes_modal_empty_msg = 'No field-level changes detected.'
      } else {
        this.changes_modal_changes = []
        this.changes_modal_empty_msg = 'No prior update in the selected range to compare against.'
      }
      this.changes_modal_visible = true
    },
    previous_record(item) {
      let prev = null
      for (const candidate of (this.items_full || [])) {
        if (candidate === item)
          continue
        if (String(candidate.booking_id) !== String(item.booking_id))
          continue
        if (!candidate.processed_time || candidate.processed_time >= item.processed_time)
          continue
        if (!prev || candidate.processed_time > prev.processed_time)
          prev = candidate
      }
      return prev
    },
    is_plain_object(v) {
      return v !== null && typeof v === 'object' && !Array.isArray(v)
    },
    compute_changed_fields(oldObj, newObj) {
      const changes = []
      const skip = new Set(['departureLatitude', 'departureLongitude', 'arrivalLatitude', 'arrivalLongitude', 'timezone', 'tbn_booking_hash'])
      const walk = (a, b, path) => {
        if (this.is_plain_object(a) && this.is_plain_object(b)) {
          const keys = new Set([...Object.keys(a), ...Object.keys(b)])
          for (const key of keys) {
            if (skip.has(key))
              continue
            const p = path.concat(this.humanize_label(key))
            if (!(key in a))
              this.collect_leaves(b[key], p, 'added', changes)
            else if (!(key in b))
              this.collect_leaves(a[key], p, 'removed', changes)
            else
              walk(a[key], b[key], p)
          }
          return
        }
        if (Array.isArray(a) && Array.isArray(b)) {
          const len = Math.max(a.length, b.length)
          for (let i = 0; i < len; i++) {
            const p = path.concat('#' + (i + 1))
            if (i >= a.length)
              this.collect_leaves(b[i], p, 'added', changes)
            else if (i >= b.length)
              this.collect_leaves(a[i], p, 'removed', changes)
            else
              walk(a[i], b[i], p)
          }
          return
        }
        if (JSON.stringify(a) !== JSON.stringify(b)) {
          const label = path.join(' › ')
          changes.push({ label, type: 'changed', old: this.leaf_display(label, a), new: this.leaf_display(label, b) })
        }
      }
      walk(oldObj || {}, newObj || {}, [])
      return changes
    },
    collect_leaves(value, path, type, changes) {
      if (this.is_plain_object(value)) {
        for (const key of Object.keys(value))
          this.collect_leaves(value[key], path.concat(this.humanize_label(key)), type, changes)
      } else if (Array.isArray(value)) {
        value.forEach((item, i) => this.collect_leaves(item, path.concat('#' + (i + 1)), type, changes))
      } else {
        const label = path.join(' › ')
        const entry = { label, type }
        if (type === 'added')
          entry.new = this.leaf_display(label, value)
        else
          entry.old = this.leaf_display(label, value)
        changes.push(entry)
      }
    },
    humanize_label(key) {
      return String(key)
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase())
    },
    leaf_display(label, v) {
      if (typeof v === 'boolean')
        return v ? 'Yes' : 'No'
      if (v === null || v === undefined || v === '')
        return '(none)'
      if (/(time|date)/i.test(label || '') && (typeof v === 'string' || typeof v === 'number')) {
        const m = moment(v)
        if (m.isValid())
          return m.format('MMM D, YYYY h:mm A')
      }
      return String(v)
    }

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    },
    text_filter() {
      this.filter_results()
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_toDate = this.details_fromDate
    }
  }
}
</script>

<style scoped>
div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.chg-view {
  font-size: 13px;
}

.chg-row {
  display: flex;
  gap: 14px;
  padding: 6px 0;
  align-items: baseline;
  border-bottom: 1px solid #f0f0f0;
}

.chg-label {
  flex: 0 0 300px;
  font-weight: 600;
  color: #333;
  word-break: break-word;
}

.chg-val {
  flex: 1;
  min-width: 0;
  word-break: break-word;
}

.chg-old {
  color: #c62828;
  text-decoration: line-through;
}

.chg-new {
  color: #2e7d32;
}

.chg-arrow {
  margin: 0 8px;
  color: #888;
}

.chg-tag {
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  padding: 1px 6px;
  border-radius: 3px;
  margin-right: 6px;
}

.chg-tag-added {
  background: #e3f3e3;
  color: #2e7d32;
}

.chg-tag-removed {
  background: #fbe3e3;
  color: #c62828;
}
</style>
